module.exports = __webpack_public_path__ + "static/media/ventures__avatar.528d968e.jpg";